import React from "react";
import { Zap, X } from "lucide-react";

const fmtDate = (d) => {
  if (!d) return "";
  try { return new Date(`${d}T00:00:00`).toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" }); }
  catch { return d; }
};

// A quick overview of the LAST occurrence in this recurring series — auto-
// shown when the call starts, anchored to the left (opposite the tool dock
// on the right) so it never covers the video. Just a summary + close button,
// not a live AI call: the data (seriesOccurrences) is already fetched for
// the History tool, so opening this is instant.
export default function LastMeetingOverview({ occurrence, onClose }) {
  return (
    <div style={{ position: "fixed", top: 20, left: 20, width: 380, maxWidth: "calc(100vw - 40px)",
      zIndex: 1001, background: "rgba(10,20,35,0.96)", backdropFilter: "blur(16px)", WebkitBackdropFilter: "blur(16px)",
      border: "1px solid rgba(0,200,255,0.25)", borderRadius: 14, boxShadow: "0 12px 40px rgba(0,0,0,0.45)",
      fontFamily: "Outfit,sans-serif", animation: "hmFadeUp 0.25s ease both", maxHeight: "50vh",
      display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px",
        borderBottom: "1px solid rgba(255,255,255,0.08)", flexShrink: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Zap size={15} color="#00C8FF" />
          <span style={{ fontSize: 13.5, fontWeight: 700, color: "#E8F0FE" }}>Last Meeting Overview</span>
        </div>
        <button onClick={onClose} title="Close" style={{ background: "none", border: "none", cursor: "pointer", color: "#7A93B4", display: "flex" }}>
          <X size={17} />
        </button>
      </div>

      <div className="hm-scroll" style={{ padding: "14px 16px", overflowY: "auto" }}>
        {!occurrence ? (
          <div style={{ fontSize: 12.5, color: "#7A93B4" }}>No previous session yet — this is the first one.</div>
        ) : (
          <>
            <div style={{ fontSize: 10.5, color: "#7A93B4", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>
              {fmtDate(occurrence.meeting_date)}
            </div>
            {occurrence.summary ? (
              <p style={{ fontSize: 13, color: "#E8F0FE", lineHeight: 1.6, margin: 0 }}>{occurrence.summary}</p>
            ) : (
              <p style={{ fontSize: 12.5, color: "#3D5473", margin: 0 }}>No summary was captured for that session.</p>
            )}
            {occurrence.key_topics?.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 12 }}>
                {occurrence.key_topics.map((t, i) => (
                  <span key={i} style={{ fontSize: 10.5, padding: "3px 9px", borderRadius: 20, background: "rgba(124,92,255,0.15)", color: "#7C5CFF", fontWeight: 600 }}>{t}</span>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
